<script setup lang="ts">
import type { CSSProperties } from 'vue'

export interface ESectionProps {
  style?: CSSProperties
}

defineProps<ESectionProps>()
</script>

<template>
  <table align="center" width="100%" :border="0" cellpadding="0" cellspacing="0" role="presentation" :style="style">
    <tbody>
      <tr>
        <td>
          <slot />
        </td>
      </tr>
    </tbody>
  </table>
</template>
